import React from 'react';
import { useSEO } from '../hooks/useSEO';
import ProductHero from '../components/ProductHero';

const PROCESS = [
  { name: 'Diagnose', body: 'Understand how work actually happens.' },
  { name: 'Map', body: 'Make responsibilities, decisions and evidence requirements visible.' },
  { name: 'Design', body: 'Create the operating model.' },
  { name: 'Digitise', body: 'Configure Videra around the requirement.' },
  { name: 'Embed', body: 'Support adoption.' },
  { name: 'Improve', body: 'Use operational information to continually refine delivery.' },
];

const CAPABILITIES = [
  'Project & Programme Delivery',
  'Lifecycle Management',
  'Healthcare Estates',
  'Hard Services',
  'PFI / P3 Assurance',
  'Handback Readiness',
  'Operating Model Design',
  'Digital Implementation',
];

const V2Consultancy = () => {
  useSEO({
    title: 'Consultancy | Diagnose, design, digitise',
    description: 'Keystone works alongside organisations to understand delivery and lifecycle processes, simplify governance and create practical operating models, configured within Videra where useful.',
    path: '/consultancy',
  });

  return (
    <div data-testid="v2-consultancy">
      <ProductHero
        eyebrow="Consultancy"
        title="Technology when you want it. Experience when you need it."
        body={(
          <>
            <p>Sometimes the challenge isn&rsquo;t choosing software. It&rsquo;s understanding how the organisation should operate.</p>
            <p>Keystone works alongside organisations to understand existing delivery and lifecycle processes, identify gaps, simplify governance and create practical operating models. Where technology adds value, those models can be configured within Videra.</p>
          </>
        )}
        primary={{ label: 'Talk to Keystone', to: '/contact' }}
        testid="consultancy-hero"
      />

      <section className="py-16 md:py-24 bg-slate-50 border-y border-slate-200">
        <div className="max-w-6xl mx-auto px-4 sm:px-6 lg:px-8">
          <p className="text-xs uppercase tracking-[0.22em] text-blue-600 font-semibold mb-4">The process</p>
          <h2 className="text-3xl md:text-4xl font-medium tracking-tight text-slate-900 mb-10">Diagnose → Map → Design → Digitise → Embed → Improve.</h2>
          <div className="grid grid-cols-1 md:grid-cols-2 lg:grid-cols-3 gap-4">
            {PROCESS.map((p, i) => (
              <div key={p.name} className="bg-white border border-slate-200 rounded-xl p-6" data-testid={`consultancy-step-${p.name.toLowerCase()}`}>
                <p className="text-[11px] uppercase tracking-[0.22em] text-blue-600 font-semibold">Step 0{i+1}</p>
                <p className="mt-1 text-lg font-medium text-slate-900">{p.name}</p>
                <p className="mt-2 text-sm text-slate-600 leading-relaxed">{p.body}</p>
              </div>
            ))}
          </div>
        </div>
      </section>

      <section className="py-20 md:py-28">
        <div className="max-w-6xl mx-auto px-4 sm:px-6 lg:px-8">
          <p className="text-xs uppercase tracking-[0.22em] text-blue-600 font-semibold mb-4">Specialist capabilities</p>
          <h2 className="text-3xl md:text-4xl font-medium tracking-tight text-slate-900 mb-10">Where we go deep.</h2>
          <div className="grid grid-cols-2 md:grid-cols-4 gap-3">
            {CAPABILITIES.map((c) => (
              <div key={c} className="border border-slate-200 rounded-lg p-4 text-sm text-slate-800" data-testid={`consultancy-capability-${c.toLowerCase().replace(/\W+/g,'-')}`}>{c}</div>
            ))}
          </div>
        </div>
      </section>
    </div>
  );
};

export default V2Consultancy;
